import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default function VerifyOtp({ email, onNext }) {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) return toast.error("Enter a valid 6-digit OTP.");

    setLoading(true);
    try {
      const res = await axios.post("https://globisun-app.onrender.com/api/auth/verify-reset-otp", { email, otp });
      toast.success(res.data.msg || "OTP verified successfully!");
      onNext(3, { tempToken: res.data.tempToken });
    } catch (err) {
      toast.error(err.response?.data?.msg || "Invalid or expired OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-step">
      <h2>Verify OTP</h2>
      <p>Enter the 6-digit OTP sent to {email}</p>
      <form onSubmit={handleVerify}>
        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          maxLength={6}
          required
          disabled={loading}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </button>
      </form>
    </div>
  );
}
